<div class="print-color">
  <mat-form-field appearance="outline" class="print-color__hex">
    <mat-label>{{ label }}</mat-label>
    <span matPrefix class="print-color__swatch-wrap">
      <input
        class="print-color__swatch"
        type="color"
        [attr.aria-label]="label"
        [value]="hexValue"
        (input)="onPickerInput($any($event.target).value)"
      />
    </span>
    <input
      matInput
      type="text"
      maxlength="7"
      [value]="hexValue"
      (input)="onHexInput($any($event.target).value)"
      (blur)="onHexBlur($any($event.target).value)"
    />
  </mat-form-field>
  @if (showCmyk) {
    <div
      class="print-color__cmyk"
      role="group"
      [attr.aria-label]="'printCards.colorCmykGroup' | translate"
    >
      <mat-form-field
        appearance="outline"
        class="print-color__channel"
        floatLabel="always"
      >
        <mat-label>{{ "printCards.colorCmykC" | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          max="100"
          step="1"
          [value]="cmyk.c"
          (input)="onCmykInput('c', $any($event.target).value)"
          (blur)="onCmykBlur('c', $any($event.target).value)"
        />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="print-color__channel"
        floatLabel="always"
      >
        <mat-label>{{ "printCards.colorCmykM" | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          max="100"
          step="1"
          [value]="cmyk.m"
          (input)="onCmykInput('m', $any($event.target).value)"
          (blur)="onCmykBlur('m', $any($event.target).value)"
        />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="print-color__channel"
        floatLabel="always"
      >
        <mat-label>{{ "printCards.colorCmykY" | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          max="100"
          step="1"
          [value]="cmyk.y"
          (input)="onCmykInput('y', $any($event.target).value)"
          (blur)="onCmykBlur('y', $any($event.target).value)"
        />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="print-color__channel"
        floatLabel="always"
      >
        <mat-label>{{ "printCards.colorCmykK" | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          max="100"
          step="1"
          [value]="cmyk.k"
          (input)="onCmykInput('k', $any($event.target).value)"
          (blur)="onCmykBlur('k', $any($event.target).value)"
        />
      </mat-form-field>
    </div>
  }
</div>
